import type { Color, Corners } from './CheckBox.h'

import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import { Background, BorderColors } from './CheckBox.h'

export const Checkmark = styled.span<{
  corners: Corners
  borderColor: BorderColors
  background: Background
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border-radius: ${({ corners }) => (corners ? `var(${corners})` : 0)};
  border: 1px solid
    ${({ borderColor }) =>
      `var(${borderColor || BorderColors.SURFACE_OPACITY_LIGHT_10})`};
  backdrop-filter: blur(35px);
  background: ${({ background }) =>
    `var(${background || Background.SURFACE_OPACITY_LIGHT_10})`};

  ${IconSC} {
    display: none;
    position: absolute;
    top: 1px;
    left: 1px;
  }
`

export const Label = styled.label<{
  backgroundHovered: Background
  borderColorHovered: BorderColors
  borderColorChecked: BorderColors
  backgroundChecked: Background
  backgroundDisabled: Background
  borderColorDisabled: BorderColors
  colorDisabled: Color
  colorDefault: Color
}>`
  display: block;
  position: relative;
  cursor: pointer;
  width: fit-content;

  input {
    position: relative;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  &:hover input ~ ${Checkmark}, &.hover input ~ ${Checkmark} {
    background: ${({ backgroundHovered }) =>
      `var(${backgroundHovered || Background.SURFACE_OPACITY_LIGHT_10})`};
    border-color: ${({ borderColorHovered }) =>
      `var(${borderColorHovered || BorderColors.SURFACE_OPACITY_LIGHT_10})`};
  }

  &:hover input:checked ~ ${Checkmark}, &.hover input:checked ~ ${Checkmark} {
    border: 1px solid
      ${({ borderColorChecked }) =>
        `var(${borderColorChecked || BorderColors.SURFACE_OPACITY_LIGHT_10})`};

    ${IconSC} {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  input:checked ~ ${Checkmark} {
    background: ${({ backgroundChecked }) =>
      `var(${backgroundChecked || Background.SURFACE_OPACITY_LIGHT_10})`};
    border: none;

    ${IconSC} {
      color: ${({ colorDefault }) =>
        colorDefault ? `var(${colorDefault})` : 'unset'};
      display: block;
    }
  }

  input:disabled ~ ${Checkmark} {
    background: ${({ backgroundDisabled }) =>
      `var(${backgroundDisabled || Background.DISABLED})`};
    border-color: ${({ borderColorDisabled }) =>
      `var(${borderColorDisabled || BorderColors.SURFACE_OPACITY_LIGHT_10})`};
    cursor: not-allowed;
  }

  input:checked:disabled ~ ${Checkmark} {
    background: ${({ backgroundDisabled }) =>
      `var(${backgroundDisabled || Background.DISABLED})`};
    border: none;
    cursor: not-allowed;

    ${IconSC} {
      color: ${({ colorDisabled }) =>
        colorDisabled ? `var(${colorDisabled})` : 'unset'};
      display: block;
      top: 1px;
      left: 1px;
    }
  }
`

export const CheckBoxWrapper = styled.div<{ label?: string }>`
  --padding-for-title: 26px;
  --positionCheckmarkWithLabel: 2px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${Checkmark} {
    top: ${({ label }) => (label ? `var(--positionCheckmarkWithLabel)` : 0)};
  }

  ${TextBoxSC} {
    padding-left: var(--padding-for-title);
  }
`
